export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="w-full bg-gray-100 border-t border-gray-200 py-12 px-6 md:px-10"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          {/* Logo + Name */}
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/380df72c-04f1-4058-977d-fe15772f1a53.png"
              alt="MELTI SRL"
              className="h-8 w-auto object-contain"
            />
            <div>
              <span
                className="text-gray-900 text-sm font-700 tracking-widest uppercase block"
                style={{ fontWeight: 700 }}
              >
                MELTI SRL
              </span>
              <span className="text-gray-400 text-xs">iOS App Development</span>
            </div>
          </div>

          {/* Nav Links */}
          <nav className="flex gap-6 flex-wrap">
            {['About', 'Products', 'Contact'].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector(`#${item.toLowerCase()}`);
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-gray-500 text-xs tracking-wide hover:text-gray-800 transition-colors cursor-pointer"
              >
                {item}
              </a>
            ))}
          </nav>

          {/* Copyright */}
          <p className="text-gray-400 text-xs">
            &copy; {year} MELTI SRL. All rights reserved.
          </p>
        </div>

        <div className="h-px bg-gray-200 mt-8 mb-6"></div>

        <p className="text-gray-400 text-xs text-center leading-relaxed max-w-2xl mx-auto">
          MELTI SRL &mdash; Registered in Romania, Sfantu Gheorghe, 520042. Developing modern iOS applications
          to enhance user experience and improve the security of mobile devices.
        </p>
      </div>
    </footer>
  );
}
